import clearTime from '@/utils/clear-time-from-date';

export default (date) => {
  const argDate = clearTime(date).getTime();
  const today = clearTime(new Date()).getTime();

  return argDate === today;
};
